import React, { Component } from 'react'
import Swipeable from 'react-swipeable'
import { throttle } from 'lodash'
import { ChromePicker } from 'react-color'
import Rendering from 'components/rendering'
import SelectContentDropdown from './select-content-dropdown'
import SelectNext from './select-next'
import enhance from './enhance'
import constants from '../../constants'
import './select-content.css'

const ANIMATION_TIME = 500

class SelectContent extends Component {
  constructor(props) {
    super(props)
    const wait = func => throttle(func, ANIMATION_TIME, { trailing: false })
    this.slideNext = wait(this.slideNext.bind(this))
    this.slidePrev = wait(this.slidePrev.bind(this))
    this.selectOption = wait(this.selectOption.bind(this))
    this.slide = 'next'
  }

  componentDidMount() {
    this.props.fetch()
  }

  selectOption(event) {
    const id = event.target.value
    const slide = this.props.selectedContentId > id ? 'prev' : 'next'
    this.slide = slide
    this.props.selectContentId(id)
  }

  slideNext() {
    this.slide = 'next'
    this.props.selectNextContentId()
  }

  slidePrev() {
    this.slide = 'prev'
    this.props.selectPrevContentId()
  }

  render() {
    return (
      <Swipeable
        onSwipingRight={() => !this.props.isSelectingColor && this.slidePrev()}
        onSwipingLeft={() => !this.props.isSelectingColor && this.slideNext()}
      >
        <div className="renderings">
          <Rendering
            selectedContent={this.props.selectedContent}
            slide={this.slide}
          />
        </div>
        <div className="actions select-content-type">
          <div className="action-nav">
            <div
              onClick={() =>
                this.props.selectContentType(
                  constants.createNav.SELECT_CONTENT_TYPE_COLOR,
                )
              }
              className={`sub-heading ${this.props.isSelectingColor &&
                'selected'}`}
            >
              Colors
            </div>
            <div
              onClick={() =>
                this.props.selectContentType(
                  constants.createNav.SELECT_CONTENT_TYPE_THEME,
                )
              }
              className={`sub-heading ${!this.props.isSelectingColor &&
                'selected'}`}
            >
              Themes
            </div>
          </div>
          <div>
            {this.props.isSelectingColor ? (
              <div className="color-picker">
                <ChromePicker
                  color={this.props.selectedContentColor}
                  onChangeComplete={color =>
                    this.props.selectContentColor(color.rgb)
                  }
                  disableAlpha
                />
              </div>
            ) : (
              <div>
                <SelectNext
                  slidePrev={this.slidePrev}
                  slideNext={this.slideNext}
                />
                <SelectContentDropdown
                  selectOption={this.selectOption}
                  content={this.props.content}
                  contentIds={this.props.contentIds}
                  selectedContent={this.props.selectedContent}
                  selectedContentId={this.props.selectedContentId}
                  defaultContentId={this.props.defaultContentId}
                  check={this.props.check}
                />
              </div>
            )}
          </div>
        </div>
      </Swipeable>
    )
  }
}

export default enhance(SelectContent)



// WEBPACK FOOTER //
// ./src/components/select-content/index.js